export default "__VITE_ASSET__BQO4d7Gc__"